import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

/**
 * API Interceptor
 * Note: Headers are already added in BackendConfig.getApiConfig() based on the service field
 * This interceptor can be used for other cross-cutting concerns if needed
 */
export const apiInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    // Headers are already managed by BackendConfig.getApiConfig()
    // Additional logic can be added here if needed
    return next(req);
};
